<template>

  <el-row :gutter="5">
    <el-col :span="6"></el-col>
    <el-col :span="12"><h2 class="heading">My Deck Documents</h2></el-col>
    <el-col :span="6" style="padding-top:20px;">
        <el-button v-if="global.hasRight('deck-docs', 'compliance')"  @click="$router.push('/deck/allDeckDocuments')">
            <el-icon><Search/></el-icon> &nbsp; All Deck Documents</el-button>
        <el-button style="margin-left:20px;" @click="$router.push('/deck/editDeckDocument')" >
            <el-icon><Plus/></el-icon> &nbsp; Add Deck Document</el-button>
    </el-col>
  </el-row>

  <el-table :data="deckList" height="88%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName"
        :default-sort="{ prop: prop, order: order }" @sort-change="sortChange">
    <el-table-column prop="id" label="No" align="center" sortable="custom" width="60"/>
    <el-table-column prop="type" label="Type" align="center" sortable="custom" width="80"/>
    <el-table-column prop="title" label="Title" width="400" sortable="custom"/>
    <el-table-column prop="creator" label="Creator" sortable="custom" />
    <el-table-column prop="authors" label="Authors" sortable="custom" >
        <template #default="scope">{{scope.row.authors.replace(/,/g, ", ")}}</template>
    </el-table-column>
    <el-table-column prop="etfs" label="ETFs" sortable="custom">
        <template #default="scope">{{scope.row.etfs.replace(/,/g, ", ")}}</template>
    </el-table-column>
    <el-table-column prop="publishDate" label="Publish date" align="center" sortable="custom"/>
    <el-table-column prop="status" label="Status" align="center" sortable="custom"/>
    <el-table-column prop="createTime" label="Create time" align="center" sortable="custom"/>
    <el-table-column prop="status" label="Action" align="center">
        <template #default="scope">
            <a href="" v-if="scope.row.status=='new' && global.hasRight('deck-docs', 'compliance')" 
                @click.prevent="$router.push('/deck/viewDeckDocument?code=' + scope.row.idMD5)" title="Approve" class="op">
                Approve
            </a>
            <el-icon v-else :size="16" @click="$router.push('/deck/viewDeckDocument?code=' + scope.row.idMD5)" style="cursor:pointer" 
                title="View details" class="op">
                <document />
            </el-icon>
            <el-icon :size="16" v-if="(scope.row.status=='new' || scope.row.status=='rejected') && global.currentUser.loginname == scope.row.creator" 
                @click.prevent="$router.push('/deck/editDeckDocument?code=' + scope.row.idMD5)" title="Edit" class="op">
                <Edit/>
            </el-icon>
            <el-icon :size="16" v-if="scope.row.status=='new' && global.currentUser.loginname == scope.row.creator" 
                @click="deleteDeck(scope.row.idMD5)" title="Delete this deck doc"  class="op">
                <Delete />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" :current-page="page.currPage"
    @current-change="getDeckList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Document, Search, Plus, Delete, Edit } from '@element-plus/icons-vue'

export default {
    components: {
        Document,  Search, Plus, Delete, Edit
    },
    data() {
        return {
            orderObj : {prop: "id", order: "descending"},
            currentUser: null,
            deckList: [],
            page: {currPage: 1},
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "deck";
        this.currentUser = this.global.currentUser;
        this.getDeckList(1);
    },
    methods: {
        sortChange(orderObj) {
            this.orderObj = orderObj;
            this.getDeckList(1);
        },
        async getDeckList(pageNo) {
            this.page.currPage = pageNo;
            let data = {pageNo: pageNo}; 
            if (this.orderObj.prop) {
                data["prop"] = this.orderObj.prop;
                data["order"] = this.orderObj.order;
            }
            let result = await AXIOS("/deck/myDeckDocList", data);
            if (result.success) {
                this.deckList = result.data.list;
                this.page = result.data.page;
            } else {
                this.errMsg = result.errMsg;
            }
        },
        tableRowClassName(scope) {
            return (scope.row.status == "approved" || scope.row.status == "rejected") ? "" : scope.row.status;
        },
        deleteDeck(code) {
            ElMessageBox.confirm(
                'Are you sure want to delete this deck document?',  'Warning', {
                    confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning',
                }
            ).then(async () => {
                let result = await AXIOS("/deck/deleteDeckDocument", {code : code});
                if (result.success) {
                    this.deckList.splice(this.deckList.findIndex(e => e.idMD5 == code), 1);
                    ElMessage({
                        message: 'Deleted deck document successfully!', type: 'success',
                    });
                } else {
                    ElMessage({
                        message: result.errMsg, type: 'error',
                    });
                }
            });
        }
    }
}
</script>

<style>
</style>